import styled from "styled-components";

const StyledImageInputCard = styled.div`
	.sb-image-input-card {
		padding: 0;
		border: 1px solid ${({ theme }) => theme.colors.iron};
		border-radius: 15px;
		min-height: 100px;
		display: flex;

		.ant-card-body {
			width: 100%;
			display: flex;

			padding: 16px;
			justify-content: space-between;
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				flex-direction: column;
			}
		}

		&__left {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
			width: 100%;
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				width: 100%;
				margin-bottom: 16px;
			}

			&__title,
			&__subtitle {
				margin-bottom: 8px;
			}
			&__title {
				font-size: 20px;
			}
			&__subtitle {
				font-size: 16px;
			}
			&__description {
				font-size: 14px;
				font-weight: 400;
				font-family: DM Sans;
				font-style: normal;
				color: rgba(140, 140, 140, 1);
			}
		}

		&__right {
			display: flex;
			@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
				.image-upload-container {
					width: 48px !important;
					height: 48px !important;
					min-width: 48px !important;
					min-height: 48px !important;
					border-radius: 5px;
				}
				width: 100%;
				.sb-image-upload {
					justify-content: flex-start;
					width: 100%;
				}
			}
		}
	}

	@media (max-width: ${({ theme }) => theme.responsive.mobile}) {
		&__card {
			.ant-card-body {
				flex-direction: column-reverse;
			}

			&__left {
				width: 100%;
				padding: 16px;

				&__title,
				&__subtitle,
				&__description {
					text-align: center;
				}
			}

			&__right {
				width: 100%;
				margin-bottom: 16px;
				height: 310px;
			}
		}
	}
`;

export default StyledImageInputCard;

